import styled from 'styled-components'

export const FixedFooter = styled.div`
  position: fixed;
  background-color: white;
  padding: 10px 15px;
  bottom: 0px;
  width: inherit;
`
